import Utils from "../../utils/Utils";

export default {

    init() {

        const INPUT_TAXABLE = "#input-taxable";
        const INPUT_TAX = "#input-tax";
        const INPUT_COST_I = "#input-cost-i";
        const INPUT_TAX_I = "#input-tax-i";
        const INPUT_TOTAL = "#input-total";

        function getTaxable() {
            const taxable = $(INPUT_TAXABLE).val();

            if (Utils.isEmpty(taxable)) {
                return 0;
            }

            return parseFloat(taxable);
        }

        function getTax() {
            const tax = $(INPUT_TAX).val();

            if (Utils.isEmpty(tax)) {
                return 0;
            }

            return parseFloat(tax);
        }

        function getCostI() {
            const cost_i = $(INPUT_COST_I).val();

            if (Utils.isEmpty(cost_i)) {
                return 0;
            }

            return parseFloat(cost_i);
        }

        function getTaxI() {
            const tax_i = $(INPUT_TAX_I).val();

            if (Utils.isEmpty(tax_i)) {
                return 0;
            }

            return parseFloat(tax_i);
        }

        function setTotal(taxable, tax, cost_i, tax_i) {

            const total = taxable + tax + cost_i + tax_i;

            $(INPUT_TOTAL).val(Math.round((total + Number.EPSILON) * 100) / 100);
        }

        function fillData() {
            const taxable = getTaxable();
            const tax = getTax();
            const cost_i = getCostI();
            const tax_i = getTaxI();

            setTotal(taxable, tax, cost_i, tax_i);
        }

        $(INPUT_TAXABLE).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAXABLE).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAX).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAX).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_COST_I).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_COST_I).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAX_I).change(function (e) {
            e.preventDefault();
            fillData();
        });

        $(INPUT_TAX_I).keyup(function (e) {
            e.preventDefault();
            fillData();
        });

        fillData();
    },

    finalize() {

    }
}
